/**
 * 弹窗分析埋点封装（§8.1.2 / §11 #16）
 *
 * 公共字段（activity_id / type / surface / source）+ ActivityStore.trackParams 自动补齐；
 * 参数随数据沉淀，不经 tryShow 传入。
 */

import { useActivityStore } from '@/store/activity';
import { useActivityQueueStore } from '@/store/activity-queue';
import { trackCustom, ETrackerEvents } from '@/utils/tracker';

import type { TDismissReason } from '../types';

type TPopupTrackEvent =
    | typeof ETrackerEvents.POP_UP_TRIGGER
    | typeof ETrackerEvents.POP_UP_SHOW
    | typeof ETrackerEvents.POP_UP_CLICK
    | typeof ETrackerEvents.POP_UP_NO_SHOW;

interface ITrackPopupOpts {
    /** 活动 id */
    activityId: string;
    /** 表面：弹窗 / 挂件 */
    surface?: 'popup' | 'widget';
    /** 未展示 / 关闭原因（诊断用） */
    reason?: TDismissReason | (string & {});
    /** 业务附加字段 */
    extra?: Record<string, unknown>;
}

/**
 * 打弹窗分析埋点；公共字段从 ActivityStore + 当前 task 自动补齐。
 * @param event 埋点事件名
 * @param opts 活动 id 与附加字段
 */
export function trackPopup(event: TPopupTrackEvent, opts: ITrackPopupOpts): void {
    const { activityId, surface = 'popup', reason, extra } = opts;
    const activity = useActivityStore.getState().getActivity(activityId);
    const { current, activeScene } = useActivityQueueStore.getState();
    const source = current?.activityId === activityId ? current.source : undefined;

    trackCustom(event, {
        activity_id: activityId,
        pop_up_type: activity?.type,
        surface,
        source,
        trigger_scene: activeScene ?? current?.scene,
        reason,
        ...activity?.trackParams,
        ...extra,
    });
}

/**
 * 诊断：入队未展示 / 兜底释放等「拉到没弹」路径（§9）。
 * @param opts 活动 id 与 reason
 */
export function trackPopupNoShow(opts: ITrackPopupOpts): void {
    trackPopup(ETrackerEvents.POP_UP_NO_SHOW, opts);
}
